import { scrollBarCheck } from '../../../../lib/utils';
import { SIDEBAR_VIEWS } from '../../../../lib/constants';
import AlertCircle from '../../../../assets/svg/Feather/AlertCircle';
import CreateCollectionsModal from '../../../Modals/CreateCollectionModal';
export default (dispatch) => ({
  collectionClicked: (selectedCollection) => {
    dispatch({
      type: 'collections/setSelectedCollectionLoading',
      payload: true
    });
    dispatch({
      type: 'app/gotoSidebarWithHistory',
      payload: SIDEBAR_VIEWS.Collection,
    });
    dispatch({
      type: 'collections/getCollectionEffect',
      payload: selectedCollection.uuid,
      callback: (collection, error) => {
        if (collection) {
          dispatch({
            type: 'collections/setSelectedCollection',
            payload: selectedCollection
          });
          dispatch({
            type: 'collections/setPreviousCollectionState',
            payload: collection,
          });
          dispatch({
            type: 'app/setSideBarScrollPosition',
            payload: { hunts: selectedCollection.uuid },
          })
          dispatch({
            type: 'features/resetAllSelectedFeatures',
          });
          dispatch({
            type: 'map/goToExtentOfFeatures',
            payload: collection.featureIds,
          });
        } else {
          dispatch({
            type: 'app/navSidebarBack'
          });
          dispatch({
            type: 'collections/setSelectedCollection',
            payload: null
          });
          let toastPayloadText = 'Oops, there was an issue retrieving the hunt'
          if (error.status == 404) {
            toastPayloadText = 'Sorry, but it looks like that hunt does not exist'
            dispatch({
              type: 'collections/deleteHuntFromUserData',
              payload: selectedCollection.uuid
            });
          }
          dispatch({
            type: 'toast/show',
            payload: {
              text: toastPayloadText,
              icon: AlertCircle,
              iconColor: '#ff3b30',
              dismissable: true,
            },
          });
        }
        dispatch({
          type: 'collections/setSelectedCollectionLoading',
          payload: false
        });
      },
    });
  },
  gotoSidebarWithHistory: (sidebarView) => {
    dispatch({
      type: 'app/gotoSidebarWithHistory',
      payload: sidebarView,
    });
  },
  createCollectionsModal: () => {
    dispatch({
      type: 'modals/add',
      payload: {
        component: CreateCollectionsModal,
        props: {},
      },
    });
  },
  displayModal: (component, props = {}) => {
    dispatch({
      type: 'modals/add',
      payload: {
        component,
        props
      }
    });
  },
  setHasScrollBar: (id) => {
    const hasScrollBar = scrollBarCheck(id)
		dispatch({
      type: 'app/setSidebarHasScrollBar',
      payload: hasScrollBar
    })
  }
});
